// extracted by mini-css-extract-plugin
export default {"info":"thank-you_info__iaEfp","contact":"thank-you_contact__TKads"};